import { createReducer, on } from '@ngrx/store';

import { AnalyticsState, initAnalyticsState } from './analytics.state';
import { AnalyticsActions } from './analytics.actions';

export const analyticsReducer = createReducer(
  initAnalyticsState,

  on(
    AnalyticsActions.loadAvailableChronosFeatures.attempt,
    (state): AnalyticsState => {
      return {
        ...state,
        devicesWithAvailableFeatures: {
          value: null,
          loading: true,
          error: null,
        },
      };
    }
  ),
  on(
    AnalyticsActions.loadAvailableChronosFeatures.success,
    (state, { deviceWithAvailableFeatures }): AnalyticsState => {
      return {
        ...state,
        devicesWithAvailableFeatures: {
          value: deviceWithAvailableFeatures,
          loading: false,
          error: null,
        },
      };
    }
  ),
  on(
    AnalyticsActions.loadAvailableChronosFeatures.error,
    (state, { error }): AnalyticsState => {
      return {
        ...state,
        devicesWithAvailableFeatures: {
          value: null,
          loading: false,
          error,
        },
      };
    }
  ),
  on(
    AnalyticsActions.hemsFeaturesPresentSince.attempt,
    (state): AnalyticsState => ({
      ...state,
      hemsFeaturesPresentSince: {
        value: null,
        loading: true,
        error: null,
      },
    })
  ),
  on(
    AnalyticsActions.hemsFeaturesPresentSince.success,
    (state, { hemsFeaturesPresentSince }): AnalyticsState => ({
      ...state,
      hemsFeaturesPresentSince: {
        value: hemsFeaturesPresentSince,
        loading: false,
        error: null,
      },
    })
  ),
  on(
    AnalyticsActions.hemsFeaturesPresentSince.error,
    (state, { error }): AnalyticsState => ({
      ...state,
      hemsFeaturesPresentSince: {
        value: null,
        loading: false,
        error,
      },
    })
  )
);
